import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaSf040 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        unitSubunitId: string // 配信単位単元ID
      }
    }

    // API Response
    export interface PieceInfoNode {
      pieceId: string // コマID
      pieceName: string // コマ名称
      pieceTypeId: string // コマ区分ID
      isPieceStatus: boolean // コマ学習活性フラグ
      isResultInfo: boolean // 正誤情報有無（コマ学習活性フラグが活性の場合に使用する）
      essentialStudyStatus: number // 要点学習取組ステータス(0: 要点学習なし, 1: 未取組, 2: 取組済)
      exerciseStatus: number // 問題演習取組ステータス(0: 問題演習なし, 1: 未取組, 2: 取組済)
    }
    export interface Response {
      unitId: string // 配信単位ID
      subunitId: string // 単元ID
      subunitName: string // 単元名称
      piecesInfoList: PieceInfoNode[]
    }

    // API Path
    export const path: string = '/ta/learningIndex'
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        unitId: '',
        subunitId: '',
        subunitName: '',
        piecesInfoList: [
          {
            pieceId: '',
            pieceName: '',
            pieceTypeId: '',
            isPieceStatus: false,
            isResultInfo: false,
            essentialStudyStatus: 0,
            exerciseStatus: 0,
          },
        ],
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
